import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import FileUploadWidget from '../containers/widgets/FileUploadWidget';
import FileRow from './FileRow';

class FileUploadItem extends Component {
    static propTypes = {
        uploadedFile: PropTypes.shape({
            userFirstName: PropTypes.string,
            fileName: PropTypes.string,
            fileType: PropTypes.string,
            createdOn: PropTypes.string,
            version: PropTypes.number,
            updatedOn: PropTypes.string
        }),
        title: PropTypes.string,
        description: PropTypes.string,
        parentId: PropTypes.string,
        parentType: PropTypes.string,
        onFileUpload: PropTypes.func
    };

    render() {
        const { title, description, parentId, parentType, onFileUpload, uploadedFile } = this.props;
        return (
            <div className={'fileUploadItem'}>
                <h3>{title}</h3>
                <div>{description}</div>
                <FileUploadWidget
                    parentId={parentId}
                    parentType={parentType}
                    handleFile={onFileUpload}
                    showFiles={false}
                />
                {!isEmpty(uploadedFile) ? <FileRow file={uploadedFile} hideDate={true} /> : null}
            </div>
        );
    }
}

export default FileUploadItem;
